export { createCloseEvent, Dialog } from '../dialog';
export type { TDialogCloseReason, TDialogProps } from '../dialog';
